<script>
  export let source = "";

  const initEditor = async (node) => {
    const Viewer = (await import("@toast-ui/editor/dist/toastui-editor-viewer"))
      .default;
    let options = {
      height: "300px",
      initialValue: source,
      linkAttribute: {
        target: "_blank",
      },
    };
    options.el = node;
    let viewer = new Viewer(options);
    return {
      destroy() {
        viewer.remove();
      },
    };
  };
</script>

{#if source}
  <div use:initEditor />
{/if}
